import { useId } from 'react'

import type { InputHTMLAttributes, JSX } from 'react'

type SalaryInputProps = {
  value: number
  onChange: (value: number) => void
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type' | 'min' | 'max' | 'step'>

const format = (value: number): string => (value === 0 ? 'Any' : `$${value / 1000}k+`)

/** A native range slider for the minimum salary, in $10k steps. `...rest` lands on the `<input>`. */
export default function SalaryInput({ value, onChange, ...rest }: SalaryInputProps): JSX.Element {
  const id = useId()
  const text = format(value)

  return (
    <div className="flex flex-col gap-1 font-sans">
      <div className="flex items-baseline justify-between gap-4">
        <label htmlFor={id} className="text-xs font-medium text-ink">
          Minimum salary
        </label>
        <span className="text-sm text-ink">{text}</span>
      </div>
      <input
        {...rest}
        id={id}
        type="range"
        min={0}
        max={100000}
        step={10000}
        value={value}
        aria-valuetext={text}
        onChange={(event) => onChange(Number(event.target.value))}
        className="min-h-11 w-full accent-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      />
    </div>
  )
}
